import { render } from "./blog-category.vue?vue&type=template&id=51a21268"
import script from "./blog-category.vue?vue&type=script&lang=js"
export * from "./blog-category.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__